module.exports = __webpack_public_path__ + "img/business_bg.8c64a265.png";